'use client'

import { HTMLProps } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import clsx from 'classnames'
import useEmblaCarousel from 'embla-carousel-react'
import { useAppearance, variantsDefault } from '@/shared/utils'
import { IWorkgroupPreview } from '@/interfaces/workgroups'
import { Text } from '@/shared/ui'
import { WorkgroupCard } from './workgroup-card'
import style from './workgroups.module.scss'

interface MembersListProps extends HTMLProps<HTMLDivElement> {
  title: string
  items: IWorkgroupPreview[]
}

export const Workgroups = (props: MembersListProps) => {
  const { className, title, items } = props
  const { ref: cardsRef, animate: cardsAnimate } = useAppearance()
  const [emblaRef] = useEmblaCarousel({
    align: 'start',
    container: `.${style.cards}`,
    breakpoints: {
      '(min-width: 1024px)': { active: false },
      '(max-width: 768px)': { align: 'center' },
    },
  })

  return (
    <div className={clsx(style.container, className)}>
      <Text className={style.title} type="h2" color="dark">
        {title}
      </Text>
      <div className={style.slider} ref={emblaRef}>
        <motion.ul
          className={clsx(style.list)}
          ref={cardsRef}
          initial="hidden"
          animate={cardsAnimate}
          variants={variantsDefault}
        >
          <AnimatePresence mode="popLayout">
            {items.map((item, index) => (
              <WorkgroupCard className={style.item} {...item} key={index} index={index} />
            ))}
          </AnimatePresence>
        </motion.ul>
      </div>
    </div>
  )
}
